import React, { useEffect, useState, useCallback } from 'react'
import ReactDOM from 'react-dom/client';
import { BrowserRouter as Router, Route, Routes, useLocation } from 'react-router-dom';
import DailyPhrase from './views/daily-phrase'
import Calendar from './views/calendar'
import PhotoApproval from './views/photo-approval'
import Advices from './views/advices'
import Photo from './views/photo'
import Login from './views/login'
import PhotoInstructions from './views/photo-instructions'
import Navbar from './components/navbar'
import Home from './views/home'
import Anuncio from './components/anuncio';
import trackPathForAnalytics from './config/track';
import './style.css'

import { getAuth, onAuthStateChanged } from "firebase/auth";

const App = () => {

  const auth = getAuth();
  const { pathname, search } = useLocation();
  const [user, setUser] = useState({});
  const [open, setOpen] = useState(false);

  const analytics = useCallback(() => {
    trackPathForAnalytics({ path: pathname, search: search, title: pathname.split("/").slice(1).toString().replace(',', '/') });
  }, [pathname, search]);

  useEffect(() => {
    onAuthStateChanged(auth, (user) => {
      if (user) {
        setUser(user);
      } else setUser({});
    });
    analytics();
    return () => {
      setUser('');
    }
  }, [auth, analytics]);

  return (
    <div className='App'>
        <Navbar
          rootClassName="navbar-root-class-name5"
          auth={auth}
          user={user}
          open={open}
          action={()=>{ setOpen(!open)}}
        />
        <Routes>
          <Route element={<DailyPhrase user={user} />} exact path="/daily-phrase" />
          <Route element={<Calendar user={user} />} exact path="/calendar" />
          <Route element={<PhotoApproval user={user} />} exact path="/photo-approval" />
          <Route element={<Advices user={user} />} exact path="/advices" />
          <Route element={<Photo user={user} />} exact path="/photo" />
          <Route element={<Login user={user} />} exact path="/login" />
          <Route element={<PhotoInstructions user={user} />} exact path="/photo-instructions" />
          <Route element={<Home user={user} />} exact path="/" />
        </Routes>
        <Anuncio />
    </div>
  )
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Router>
    <App />
  </Router>
);